module.exports = __webpack_public_path__ + "11_hair_brown.bdbb6bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/11_hair_brown.png
// module id = Ez+b
// module chunks = 0